"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Text = _interopRequireDefault(require("../Text"));
var _Icon = _interopRequireDefault(require("../Icon"));
var _Theme = _interopRequireDefault(require("../Theme"));
var _NotificationBannerInline = _interopRequireDefault(require("../NotificationBannerInline"));
var _utilities = _interopRequireDefault(require("../../utilities"));
var _Label = _interopRequireDefault(require("../Label"));
var _Button = _interopRequireDefault(require("../Button"));
var _Spinner = _interopRequireDefault(require("../Spinner"));
var _constant = require("../JourneyPriceCTA/constant");
var _constant2 = require("./constant");
var _UnifiedBookingStatus = _interopRequireDefault(require("./UnifiedBookingStatus.proptypes"));
var _constant3 = require("../BookingStatus/constant");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var StyledContainer = _styledComponents.default.div.withConfig({
  displayName: "UnifiedBookingStatus__StyledContainer",
  componentId: "sc-khv9e8-0"
})(["display:flex;flex-direction:column;background:", ";box-shadow:0px 1px 4px rgba(0,0,0,0.16);border-radius:4px;"], function (_ref) {
  var theme = _ref.theme;
  return theme.backgroundColor.default;
});
var MainBannerDiv = _styledComponents.default.div.withConfig({
  displayName: "UnifiedBookingStatus__MainBannerDiv",
  componentId: "sc-khv9e8-1"
})(["display:flex;align-items:centre;justify-content:centre;flex-direction:column;margin:", ";"], function (_ref2) {
  var theme = _ref2.theme;
  return "".concat(theme.space.small, " ").concat(theme.space.none, " ").concat(theme.space.none);
});
var BannerDiv = _styledComponents.default.div.withConfig({
  displayName: "UnifiedBookingStatus__BannerDiv",
  componentId: "sc-khv9e8-2"
})(["padding:", ";"], function (_ref3) {
  var theme = _ref3.theme,
    isMobile = _ref3.isMobile;
  return isMobile ? "".concat(theme.space.none, " ").concat(theme.space.small, " ").concat(theme.space.small) : "".concat(theme.space.none, " ").concat(theme.space.standard, " ").concat(theme.space.small);
});
var StyledContentNew = _styledComponents.default.div.withConfig({
  displayName: "UnifiedBookingStatus__StyledContentNew",
  componentId: "sc-khv9e8-3"
})(["display:flex;align-items:center;justify-content:center;flex-direction:row;"]);
var StyledContent = _styledComponents.default.div.withConfig({
  displayName: "UnifiedBookingStatus__StyledContent",
  componentId: "sc-khv9e8-4"
})(["display:flex;align-items:center;justify-content:center;flex-direction:row;padding:", ";"], function (_ref4) {
  var theme = _ref4.theme,
    isMobile = _ref4.isMobile;
  return isMobile ? "".concat(theme.space.XSmall, " ").concat(theme.space.small, " ").concat(theme.space.XSmall) : "".concat(theme.space.XSmall, " ").concat(theme.space.standard, " ").concat(theme.space.XSmall);
});
var StyledSubTitle = _styledComponents.default.div.withConfig({
  displayName: "UnifiedBookingStatus__StyledSubTitle",
  componentId: "sc-khv9e8-5"
})(["max-width:375px;"]);
var StyledSubDivider = _styledComponents.default.hr.withConfig({
  displayName: "UnifiedBookingStatus__StyledSubDivider",
  componentId: "sc-khv9e8-6"
})(["border:none;border-bottom:1px solid ", ";margin:", ";"], function (_ref5) {
  var theme = _ref5.theme;
  return theme.backgroundColor.greyLine;
}, function (_ref6) {
  var theme = _ref6.theme,
    isMobile = _ref6.isMobile;
  return isMobile ? "".concat(theme.space.none, " ").concat(theme.space.small, " ").concat(theme.space.none) : "".concat(theme.space.none, " ").concat(theme.space.standard, " ").concat(theme.space.none);
});
var StyledDivider = _styledComponents.default.hr.withConfig({
  displayName: "UnifiedBookingStatus__StyledDivider",
  componentId: "sc-khv9e8-7"
})(["border:none;border-bottom:1px solid ", ";width:100%;margin:", ";"], function (_ref7) {
  var theme = _ref7.theme;
  return theme.backgroundColor.greyLine;
}, function (_ref8) {
  var theme = _ref8.theme;
  return "".concat(theme.space.none, " ").concat(theme.space.none, " ").concat(theme.space.none);
});
var ButtonDiv = _styledComponents.default.div.withConfig({
  displayName: "UnifiedBookingStatus__ButtonDiv",
  componentId: "sc-khv9e8-8"
})(["display:flex;width:", ";"], function (_ref9) {
  var isMobile = _ref9.isMobile;
  return isMobile ? 'auto' : '100%';
});

// border-radius: ${({ theme }) => `${theme.space.micro} `};
var ButtonSection = _styledComponents.default.div.withConfig({
  displayName: "UnifiedBookingStatus__ButtonSection",
  componentId: "sc-khv9e8-9"
})(["display:flex;flex-direction:", ";background-color:", ";column-gap:", ";row-gap:", ";padding:", ";"], function (_ref10) {
  var isMobile = _ref10.isMobile;
  return isMobile ? 'column' : 'row';
}, function (_ref11) {
  var theme = _ref11.theme;
  return theme.colors.greyLighter;
}, function (_ref12) {
  var theme = _ref12.theme;
  return theme.space.standard;
}, function (_ref13) {
  var theme = _ref13.theme;
  return theme.space.small;
}, function (_ref14) {
  var theme = _ref14.theme,
    isMobile = _ref14.isMobile;
  return isMobile ? "".concat(theme.space.small, " ").concat(theme.space.small, " ") : "".concat(theme.space.small, " ").concat(theme.space.standard);
});
var RefundDiv = _styledComponents.default.span.withConfig({
  displayName: "UnifiedBookingStatus__RefundDiv",
  componentId: "sc-khv9e8-10"
})(["display:flex;flex-direction:row;padding:", ";"], function (_ref15) {
  var theme = _ref15.theme,
    isMobile = _ref15.isMobile;
  return isMobile ? "".concat(theme.space.small, " ").concat(theme.space.small, " ").concat(theme.space.tiny) : "".concat(theme.space.small, " ").concat(theme.space.standard, " ").concat(theme.space.tiny);
});
var CheckingDiv = _styledComponents.default.span.withConfig({
  displayName: "UnifiedBookingStatus__CheckingDiv",
  componentId: "sc-khv9e8-11"
})(["display:flex;flex-direction:row;padding:", ";"], function (_ref16) {
  var theme = _ref16.theme,
    isMobile = _ref16.isMobile;
  return isMobile ? "".concat(theme.space.small, " ").concat(theme.space.small, " ").concat(theme.space.tiny) : "".concat(theme.space.small, " ").concat(theme.space.standard, " ").concat(theme.space.tiny);
});
var Container = _styledComponents.default.div.withConfig({
  displayName: "UnifiedBookingStatus__Container",
  componentId: "sc-khv9e8-12"
})(["color:", ";font-family:", ";font-weight:", ";font-size:", ";line-height:", ";width:", ";text-align:", ";align-items:center;margin:", ";"], function (_ref17) {
  var theme = _ref17.theme;
  return theme.colors.neutral;
}, function (_ref18) {
  var theme = _ref18.theme;
  return theme.fontFamily.default;
}, function (_ref19) {
  var theme = _ref19.theme;
  return theme.fontWeight.medium;
}, function (_ref20) {
  var theme = _ref20.theme;
  return theme.fontSize.small;
}, function (_ref21) {
  var theme = _ref21.theme;
  return theme.lineHeight.normal;
}, function (_ref22) {
  var width = _ref22.width;
  return width || '';
}, function (_ref23) {
  var textAlign = _ref23.textAlign;
  return textAlign || '';
}, function (_ref24) {
  var theme = _ref24.theme;
  return "".concat(theme.space.none, " ").concat(theme.space.micro, " ").concat(theme.space.none);
});
var IconDiv = _styledComponents.default.span.withConfig({
  displayName: "UnifiedBookingStatus__IconDiv",
  componentId: "sc-khv9e8-13"
})(["display:flex;margin:", ";"], function (_ref25) {
  var theme = _ref25.theme;
  return "".concat(theme.space.none, " ").concat(theme.space.XXXSmall, " ").concat(theme.space.none, "  ").concat(theme.space.tiny);
});
var TextDiv = _styledComponents.default.div.withConfig({
  displayName: "UnifiedBookingStatus__TextDiv",
  componentId: "sc-khv9e8-14"
})(["display:flex;align-items:left;justify-content:center;flex-direction:column;padding:", ";"], function (_ref26) {
  var theme = _ref26.theme,
    isMobile = _ref26.isMobile;
  return isMobile ? "".concat(theme.space.none, " ").concat(theme.space.small, " ").concat(theme.space.small) : "".concat(theme.space.none, " ").concat(theme.space.standard, " ").concat(theme.space.small);
});
var ReferenceDiv = _styledComponents.default.div.withConfig({
  displayName: "UnifiedBookingStatus__ReferenceDiv",
  componentId: "sc-khv9e8-15"
})(["display:flex;align-items:left;justify-content:center;flex-direction:column;padding:", ";"], function (_ref27) {
  var theme = _ref27.theme,
    isMobile = _ref27.isMobile;
  return isMobile ? "".concat(theme.space.none, " ").concat(theme.space.small, " ").concat(theme.space.none) : "".concat(theme.space.none, " ").concat(theme.space.standard, " ").concat(theme.space.none);
});
var BookingIdDiv = _styledComponents.default.div.withConfig({
  displayName: "UnifiedBookingStatus__BookingIdDiv",
  componentId: "sc-khv9e8-16"
})(["font-family:", ";font-weight:", ";font-size:", ";line-height:", ";padding-bottom:", ";"], function (_ref28) {
  var theme = _ref28.theme;
  return "".concat(theme.fontFamily.secondary);
}, function (_ref29) {
  var theme = _ref29.theme;
  return "".concat(theme.fontWeight.large);
}, function (_ref30) {
  var theme = _ref30.theme;
  return "".concat(theme.fontSize.titleNormal);
}, function (_ref31) {
  var theme = _ref31.theme;
  return "".concat(theme.fontSize.titleXNormal);
}, function (_ref32) {
  var theme = _ref32.theme;
  return "".concat(theme.space.small);
});

// const Line = styled.div`
//   border-left: ${({ theme, last }) => (last ? ` ` : `${theme.space.xxxtiny} solid ${theme.colors.greyDark}`)};
//   width: 1%;
//   padding-bottom: 50px;
//   padding-left: ${({ last }) => (last ? `5px` : ``)};
//   margin-left: 6px;
// `;

// const RefundText = styled.span`
//   color: ${({ theme, status }) => (status ? '' : theme.colors.greyDark)};
//   font-size: ${({ theme }) => theme.fontSize.small};
// `;

var UnifiedBookingStatus = function UnifiedBookingStatus(_ref33) {
  var accessible = _ref33.accessible,
    customProperties = _ref33.customProperties,
    theme = _ref33.theme,
    translation = _ref33.translation,
    state = _ref33.state,
    data = _ref33.data,
    isMobile = _ref33.isMobile,
    handleBookingCallback = _ref33.handleBookingCallback,
    templateString = _ref33.templateString,
    isloading = _ref33.isloading,
    fireGtm = _ref33.fireGtm;
  var templateStr = _objectSpread(_objectSpread({}, _constant2.TEMPLATE_STR), templateString);
  var sanitizeStr = function sanitizeStr(str) {
    return str.replace(/[{}.]/g, '');
  };
  var move = theme === _constant.THEMES.MOVE;
  // const [toggleClicked, setToggleClicked] = useState(false);
  var renderCustomText = function renderCustomText(txt) {
    // customized text to insert component/tag
    if (Object.keys(templateStr).includes(sanitizeStr(txt)) && txt.match(/[{}]/g)) {
      var templateKey = sanitizeStr(txt);
      var displayText = "".concat(txt.replace(templateStr[templateKey], data[templateKey]));
      return displayText;
    }
    return "".concat(txt, " ");
  };
  var renderContentMsg = function renderContentMsg(txt) {
    return txt.join(' ');
  };
  var getCheckedInStatus = function getCheckedInStatus(status, language, checkedInPassengers, totalPassengers) {
    if (status === _constant2.PARTIAL_CHECKEDIN) {
      var partialCheckedInMessage = language[status].replace('{0}', checkedInPassengers).replace('{1}', totalPassengers);
      return partialCheckedInMessage;
    }
    return language[status];
  };
  var language = _objectSpread(_objectSpread({}, _constant2.TRANSLATION), translation);
  var getText = function getText(_message, _customProperties, _display, _bold, _type, _textAlign, _Color) {
    return /*#__PURE__*/_react.default.createElement(_Text.default, {
      display: _display,
      customProperties: _customProperties,
      theme: theme,
      bold: _bold,
      type: _type,
      textAlign: _textAlign,
      accessible: accessible,
      color: _Color
    }, _message);
  };
  var capitalizeFirstLetter = function capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  };
  var refundEventDetails = function refundEventDetails() {
    return data.refund.events.filter(function (event) {
      return event.status;
    }).sort(function (a, b) {
      return new Date(b.dateTimeUtc) - new Date(a.dateTimeUtc);
    }).map(function (event) {
      return capitalizeFirstLetter(event.event);
    })[0];
  };

  // const showRefundSummary = (refund) => {
  //   return refund.events.map((events, index) => (
  //     <>
  //       <IconDiv>
  //         <Icon
  //           accessible={accessible}
  //           color={events.status ? 'tertiary' : 'greyDark'}
  //           fontsize={TEXT.titleSmall}
  //           icon="CheckCircleIcon"
  //           theme={theme}
  //         />
  //         <RefundText status={events.status}>{`${language.refundSummaryMessage} ${events.event}`}</RefundText>
  //       </IconDiv>
  //       <IconDiv>
  //         <Line last={index === refund.events.length - 1} />
  //         <RefundText>{events.dateTime}</RefundText>
  //       </IconDiv>
  //     </>
  //   ));
  // };

  var _useState = (0, _react.useState)(null),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    selectedIndex = _useState2[0],
    setSelectedIndex = _useState2[1];
  (0, _react.useEffect)(function () {
    if (!isloading) {
      setSelectedIndex(null);
    }
  }, [isloading]);
  var handleButtonClick = function handleButtonClick(button, index) {
    setSelectedIndex(index);
    handleBookingCallback(button.key);
  };
  var spinnerColor = function spinnerColor(index) {
    if (index !== 0) {
      return move ? 'secondary' : 'primary';
    }
    return move ? 'secondary' : 'default';
  };
  return /*#__PURE__*/_react.default.createElement(_Theme.default, {
    theme: theme
  }, /*#__PURE__*/_react.default.createElement(StyledContainer, (0, _extends2.default)({
    isMobile: isMobile
  }, customProperties, {
    tabIndex: !accessible ? '-1' : '0'
  }), /*#__PURE__*/_react.default.createElement(StyledContent, {
    isMobile: isMobile
  }, getText(language[data.bookingStatus], {
    fontWeight: _constant2.TEXT.medium
  }, _constant2.TEXT.inlineFlex, true, _constant2.TEXT.textLarge, _constant2.TEXT.center, _constant2.STATE_TEXT[state]), /*#__PURE__*/_react.default.createElement(IconDiv, null, /*#__PURE__*/_react.default.createElement(_Icon.default, {
    accessible: accessible,
    color: _constant2.STATE_ICON_COLOR[state],
    fontsize: _constant2.TEXT.titleSmall,
    icon: _constant2.STATE_ICON[state],
    theme: theme
  }))), /*#__PURE__*/_react.default.createElement(StyledDivider, null), /*#__PURE__*/_react.default.createElement(MainBannerDiv, null, data.banners && data.banners.map(function (item) {
    var bannerText = renderContentMsg(item.text.split(' ').map(function (txt, key) {
      return renderCustomText(txt, key);
    }));
    var message = [{
      text: bannerText,
      cta: item.cta,
      url: item.url,
      newTab: '',
      onClick: function onClick() {}
    }];
    var gtmErrorObj = _utilities.default.getErrorObj('bookingConfirmation', bannerText);
    return /*#__PURE__*/_react.default.createElement(BannerDiv, {
      isMobile: isMobile,
      key: item.type
    }, /*#__PURE__*/_react.default.createElement(_NotificationBannerInline.default, {
      accessible: true,
      border: true,
      closable: false,
      device: _constant2.TEXT.desktop,
      fullWidth: _constant2.TEXT.true,
      largerPadding: false,
      message: message,
      showLeftIcon: true,
      smallerPadding: false,
      textType: _constant2.TEXT.small,
      theme: theme,
      type: item.type,
      fireGtm: fireGtm,
      gtmErrorObj: gtmErrorObj
    }));
  })), data.cfar && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(RefundDiv, null, getText(language[data.cfar.message1], {
    fontWeight: _constant2.TEXT.normal
  }, _constant2.TEXT.inlineFlex, true, _constant2.TEXT.default, null, _constant2.TEXT.neutral))), /*#__PURE__*/_react.default.createElement(StyledSubTitle, null, /*#__PURE__*/_react.default.createElement(ReferenceDiv, {
    isMobile: isMobile
  }, getText(language[data.bookingText], {
    fontWeight: _constant2.TEXT.normal
  }, _constant2.TEXT.inlineFlex, true, _constant2.TEXT.small, null, _constant2.TEXT.greyDark), /*#__PURE__*/_react.default.createElement(BookingIdDiv, null, data.bookingId))), data.refund && /*#__PURE__*/_react.default.createElement(StyledSubDivider, {
    isMobile: isMobile
  }), data.refund && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(RefundDiv, {
    isMobile: isMobile
  }, getText(data.refund.events ? language.refundStatus : language[data.refund.key], {
    fontWeight: _constant2.TEXT.normal
  }, _constant2.TEXT.inlineFlex, true, _constant2.TEXT.default, null, _constant2.TEXT.neutral), /*#__PURE__*/_react.default.createElement(Container, null, /*#__PURE__*/_react.default.createElement(_Label.default, {
    theme: theme,
    labelColor: _constant2.TEXT.tertiaryLight,
    textColor: _constant2.TEXT.tertiaryDark
  }, data.refund.events ? refundEventDetails() : language[data.refund.status]))), /*#__PURE__*/_react.default.createElement(TextDiv, {
    isMobile: isMobile
  }, getText(data.refund.events ? language.refundText : language[data.refund.messageKey], {
    fontWeight: _constant2.TEXT.small
  }, _constant2.TEXT.inlineFlex, true, null, null, _constant2.TEXT.greyDark))), data.checkin && (data.bookingStatus === _constant2.BOOKING_CONFIRMED || data.bookingStatus === _constant2.BOOKING_SUCCESS) && /*#__PURE__*/_react.default.createElement(StyledSubDivider, {
    isMobile: isMobile
  }), data.checkin && (data.bookingStatus === _constant2.BOOKING_CONFIRMED || data.bookingStatus === _constant2.BOOKING_SUCCESS) && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(CheckingDiv, {
    isMobile: isMobile
  }, getText(language[_constant2.CHECKING_STATUS], {
    fontWeight: _constant2.TEXT.normal
  }, _constant2.TEXT.inlineFlex, true, _constant2.TEXT.default, null, _constant2.TEXT.neutral), /*#__PURE__*/_react.default.createElement(Container, null, /*#__PURE__*/_react.default.createElement(_Label.default, {
    theme: theme,
    labelColor: _constant2.CHECKING_STATE_LABEL_COLOR[data.checkin.status],
    textColor: _constant2.CHECKING_STATE_TEXT_COLOR[data.checkin.status]
  }, getCheckedInStatus(data.checkin.status, language, data.checkin.checkedInPassengers, data.checkin.totalPassengers)))), /*#__PURE__*/_react.default.createElement(TextDiv, {
    isMobile: isMobile
  }, getText(language[data.checkin.messageKey], {
    fontWeight: _constant2.TEXT.small
  }, _constant2.TEXT.inlineFlex, true, _constant2.TEXT.small, null, _constant2.TEXT.greyDarker))), data.buttons && /*#__PURE__*/_react.default.createElement(StyledDivider, null), data.buttons && data.bookingState !== _constant3.BOOKING_STATE.paymentPending && /*#__PURE__*/_react.default.createElement(ButtonSection, {
    isMobile: isMobile
  }, data.buttons && data.buttons.map(function (button, index) {
    return /*#__PURE__*/_react.default.createElement(ButtonDiv, {
      isMobile: isMobile,
      key: button.key
    }, /*#__PURE__*/_react.default.createElement(_Button.default, (0, _extends2.default)({}, index !== 0 && {
      border: button.borderColor
    }, {
      boxShadow: true,
      handleClick: function handleClick() {
        handleButtonClick(button, index);
      },
      width: "100%",
      buttonType: _constant2.TEXT.button,
      color: button.textColor,
      theme: theme,
      backgroundColor: button.bgColor,
      border: move ? 'secondary' : 'default'
    }), isloading && selectedIndex === index ? /*#__PURE__*/_react.default.createElement(_Spinner.default, {
      animationDuration: "1s",
      color: spinnerColor(index),
      height: "18px",
      show: true,
      strokeWidth: "3",
      theme: theme,
      width: "18px"
    }) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(StyledContentNew, null, /*#__PURE__*/_react.default.createElement(IconDiv, null, /*#__PURE__*/_react.default.createElement(_Icon.default, {
      color: button.textColor,
      accessible: accessible,
      fontsize: _constant2.TEXT.secondary,
      icon: button.icon,
      theme: theme
    })), getText(language[button.key], {}, _constant2.TEXT.inlineFlex, false, _constant2.TEXT.textLarge, null, button.textColor)))));
  }))));
};
UnifiedBookingStatus.propTypes = _UnifiedBookingStatus.default.PropTypes;
UnifiedBookingStatus.defaultProps = _UnifiedBookingStatus.default.DefaultProps;
var _default = UnifiedBookingStatus;
exports.default = _default;